import { sample } from 'effector';
import { $token } from '@features/common';
import { recordsApi } from '../../api';
import { $filters } from '../filters/filters.model';
import { $popupData } from '../records/records.model';
import { IndicatorsWidgetGate } from '../widget/widget.model';
import { fxExportTemplate, fxDownloadFile, exportTemplate, $isLoading } from './export-template.model';

import type { Payload } from './export-template.types';

type Source = [
  state: { complexId?: string },
  filters: { object?: string; house?: string; archive?: 1 | 0 },
  popupData: { level_id: number; category_id: number},
  token: string
];

type Record = {
  record?: {
    title?: string;
  }
};

fxExportTemplate.use(recordsApi.exportSignals);

$isLoading.on(fxExportTemplate.pending, (_, isLoading) => isLoading);

sample({
  clock: exportTemplate,
  source: [IndicatorsWidgetGate.state, $filters, $popupData, $token],
  fn: ([state, filters, popupData, token]: Source) => {
    const payload: Partial<Payload> = {
      level_id: popupData.level_id,
      category_id: popupData.category_id,
    };

    if (filters.object) {
      payload.complex_id = filters.object;
    }

    if (filters.house) {
      payload.building_id = filters.house;
    }

    /* parse link dashboard-fullscreen */
    if (state.complexId) {
      payload.complex_id = state.complexId;
    }

    payload.archive = filters.archive ? 1 : 0;

    payload.token = token;

    return payload;
  },
  target: fxExportTemplate,
});

sample({
  clock: fxExportTemplate.done,
  source: $popupData,
  fn: (data: Record, { result }: { result: Blob | MediaSource }): [Blob | MediaSource, string] => {
    return [result, data?.record?.title ?? ''];
  },
  target: fxDownloadFile
});
